/**
 * @param {string} title - the text to display
 * @param {React.ReactNode} children - the content
 * @returns {React.ReactNode}
 * This will only work for WebView
 */
import React from 'react';
import { Platform } from 'react-native';

type WebToolTipProp = {
  title: string;
  children: React.ReactNode;
};
export const WebToolTip = ({ title, children }: WebToolTipProp) => {
  return Platform.OS === 'web' ? <div title={title}>{children}</div> : <>{children}</>;
};
